<template lang="pug">
  div(:class="b()")
    mobile-header(
      :home-url="homeUrl"
    ).is-hidden-desktop
    desktop-header(
      :home-url="homeUrl"
    ).is-hidden-mobile.is-hidden-tablet-only
</template>

<script>
  import MobileHeader from './mobile-header';
  import DesktopHeader from './desktop-header';

  export default {
    name: 'rtc-header',

    props: {
      homeUrl: { type: String, required: true },
    },

    components: {
      MobileHeader,
      DesktopHeader,
    },
  };
</script>

<style lang="sass" scoped>
  .rtc-header
    font-family: 'Poppins', sans-serif !important
    color: white

</style>